<div class="page-wrapper">
    <sfx-loader
        class="no-flex-grow"
        [translationKey]="'global.logging_in'"
    ></sfx-loader>
    @if (hasWaitedAnExtendedPeriod()) {
        <div class="redirect-container">
            <div class="redirect-title">{{ 'auth.redirect_to_projects.title' | translate }}</div>
            <sfx-button
                type="main"
                label="auth.redirect_to_projects.button"
                (clicked)="redirectToProjects()"
            ></sfx-button>
        </div>
    }
</div>
